import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { useStrictLocalization } from "@faire/web/common/localization";
import { QuickActionType } from "../types";
export var useRetailerQuickActions = function useRetailerQuickActions() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var cancelAnOrder = {
    id: QuickActionType.CANCEL_AN_ORDER,
    label: strictLocalize({
      id: "C20NsF",
      defaultMessage: [{
        "type": 0,
        "value": "Annuler une commande"
      }]
    })
  };
  var reportDamagedOrMissingItems = {
    id: QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS,
    label: strictLocalize({
      id: "kt3VUE",
      defaultMessage: [{
        "type": 0,
        "value": "Signaler des articles endommagés ou manquants"
      }]
    })
  };
  var returnItems = {
    id: QuickActionType.RETURN_ITEMS,
    label: strictLocalize({
      id: "KraL1N",
      defaultMessage: [{
        "type": 0,
        "value": "Retourner des articles"
      }]
    })
  };
  var contactABrand = {
    id: QuickActionType.CONTACT_A_BRAND,
    label: strictLocalize({
      id: "3h04W5",
      defaultMessage: [{
        "type": 0,
        "value": "Contacter une marque"
      }]
    })
  };
  var trackAnOrder = {
    id: QuickActionType.TRACK_AN_ORDER,
    label: strictLocalize({
      id: "kKsQVA",
      defaultMessage: [{
        "type": 0,
        "value": "Suivre une commande"
      }]
    })
  };
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, QuickActionType.CANCEL_AN_ORDER, cancelAnOrder), QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS, reportDamagedOrMissingItems), QuickActionType.RETURN_ITEMS, returnItems), QuickActionType.CONTACT_A_BRAND, contactABrand), QuickActionType.TRACK_AN_ORDER, trackAnOrder);
};